module.exports = __webpack_public_path__ + "static/media/payments.47445975.svg";